<nav class="nav justify-content-end">
    <a class="nav-link active" href="#" class="text-danger">Salir</a>
</nav>